<template>
      <v-container fluid class="py-0" :class="{}">
            <v-row>
                <v-col style="position: relative">
                    <img alt="Hero Banner Image" src="/images/main/background.jpeg" :style="{
                        height: imageHeight
                    }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;
                        object-position: center;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white" class="mb-4" v-html="$t('titleScreens.agb')"></h1>
                        <a :href="$getPhoneLink()">
                            <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                            }}</v-btn>
                        </a><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                        }}</small>
                    </div>
                </v-col>
            </v-row>


            <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
                :style="{ 'margin-top': isMobile ? '-78px' : '-138px' }" :height="isMobile ? 60 : 120"
                style="z-index: 2; position: relative;" />

    </v-container>

    <v-container fluid>
        <v-row>
            <v-spacer />
            <v-col cols="10">
                <!--
    AgbView.vue — Allgemeine Geschäftsbedingungen und Kundeninformationen
    Praxis Keilberg | Heilpraktiker für Psychotherapie + SaaS-Plattform
  
    VOR VERÖFFENTLICHUNG:
    - Alle gelb markierten Platzhalter (.legal-doc__todo) befüllen oder entfernen.
    - Stand-Datum unten in `lastUpdated` setzen.
    - Anwaltliche Prüfung empfohlen (Heilpraktikerrecht, Fernabsatz, digitale Inhalte).
  -->
                <article class="legal-doc">
                    <h2 class="legal-doc__title">Allgemeine Geschäftsbedingungen und Kundeninformationen</h2>

                    <h2>§ 1 Geltungsbereich</h2>
                    <p>(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für sämtliche Verträge, die
                        Verbraucherinnen und Verbraucher (nachfolgend „Kunde“ oder „Patient“) mit dem nachstehend
                        genannten Anbieter über die Internetpräsenz und die Online-Plattform unter <span
                            class="legal-doc__todo">[Domain, z.&nbsp;B. www.praxis-keilberg.de]</span> (nachfolgend
                        „Plattform“) abschließen.</p>
                    <p>(2) Verbraucher im Sinne dieser AGB ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
                        abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen
                        Tätigkeit zugerechnet werden können (§&nbsp;13 BGB). Die Leistungen des Anbieters richten sich
                        ausschließlich an Verbraucher.</p>
                    <p>(3) Maßgeblich ist die zum Zeitpunkt des Vertragsschlusses gültige Fassung dieser AGB.
                        Abweichende oder entgegenstehende Bedingungen des Kunden werden nicht Vertragsbestandteil, es
                        sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
                    <p>(4) Der Anbieter erbringt über die Plattform zwei voneinander unabhängige Arten von Leistungen,
                        die rechtlich getrennt zu betrachten sind:</p>
                    <ul>
                        <li><strong>Bereich A – Heilpraktiker-Leistungen:</strong> psychotherapeutische Behandlung im
                            Rahmen der Tätigkeit als Heilpraktiker für Psychotherapie, einschließlich der
                            Online-Terminbuchung (§&nbsp;4 und §&nbsp;5 dieser AGB);</li>
                        <li><strong>Bereich B – Digitale Inhalte und Abonnements:</strong> Bereitstellung digitaler
                            Inhalte und digitaler Dienstleistungen, auch im Rahmen wiederkehrender Abonnements, über den
                            Online-Shop der Plattform (§&nbsp;6 und §&nbsp;7 dieser AGB).</li>
                    </ul>

                    <h2>§ 2 Anbieter / Vertragspartner</h2>
                    <p>Vertragspartner des Kunden ist:</p>
                    <address>
                        Rüdiger Keilberg<br />
                        Annastraße 9<br />
                        34119 Kassel<br />
                        Deutschland<br /><br />
                        Telefon: <a :href="phoneHref">{{ phone }}</a><br />
                        E-Mail: <a :href="mailto">{{ email }}</a>
                    </address>
                    <p>Inhaltlich verantwortlich: Rüdiger Keilberg<br />
                        Umsatzsteuer-Identifikationsnummer: DE346208291<br />
                        Steuernummer: 026/834/33066</p>
                    <p>Berufsbezeichnung: Heilpraktiker für Psychotherapie (Erlaubnis nach dem Heilpraktikergesetz,
                        beschränkt auf das Gebiet der Psychotherapie), verliehen in der Bundesrepublik Deutschland.
                        Zuständige Aufsichtsbehörde: <span class="legal-doc__todo">[zuständiges Gesundheitsamt,
                            z.&nbsp;B. Gesundheitsamt der Stadt Kassel]</span>. Mitglied im Verband Freier
                        Psychotherapeuten, Heilpraktiker für Psychotherapie und Psychologischer Berater e.&nbsp;V.
                        (VFP).</p>

                    <h2>§ 3 Begriffsbestimmungen</h2>
                    <p>(1) <strong>Digitale Inhalte</strong> sind Daten, die in digitaler Form erstellt und
                        bereitgestellt werden (z.&nbsp;B. <span class="legal-doc__todo">[Online-Kurse, Audio- und
                            Videoinhalte, E-Books, Übungs- und Arbeitsmaterialien, Mediatheken-Zugänge]</span>).</p>
                    <p>(2) <strong>Digitale Dienstleistung</strong> ist eine Dienstleistung, die dem Kunden die
                        Erstellung, Verarbeitung oder Speicherung von Daten in digitaler Form oder den Zugang zu solchen
                        Daten ermöglicht (z.&nbsp;B. der dauerhafte Zugang zu einem Inhaltebereich der Plattform).</p>
                    <p>(3) <strong>Abonnement</strong> ist ein Dauerschuldverhältnis über die fortlaufende
                        Bereitstellung digitaler Inhalte oder digitaler Dienstleistungen gegen ein wiederkehrendes
                        Entgelt.</p>
                    <p>(4) <strong>Behandlungsvertrag</strong> ist der Vertrag über die Erbringung psychotherapeutischer
                        Leistungen im Sinne der §§&nbsp;630a&nbsp;ff. BGB.</p>

                    <h2>§ 4 Online-Terminbuchung und Vertragsschluss (Bereich A)</h2>
                    <p>(1) Über die Online-Terminbuchung der Plattform kann der Patient einen Termin für eine
                        psychotherapeutische Behandlung anfragen bzw. reservieren.</p>
                    <p>(2) Die Darstellung der buchbaren Termine stellt kein bindendes Angebot dar, sondern eine
                        Aufforderung zur Abgabe eines Angebots. Mit dem Abschluss des Buchungsvorgangs gibt der Patient
                        ein verbindliches Angebot auf Abschluss eines Behandlungsvertrages für den gewählten Termin ab.
                    </p>
                    <p>(3) Der Behandlungsvertrag kommt zustande, sobald der Anbieter die Buchung in Textform
                        (z.&nbsp;B. per E-Mail) bestätigt oder den Termin durchführt. Eine automatisch erzeugte
                        Empfangsbestätigung der Buchung stellt noch keine Annahme dar, sofern sie nicht ausdrücklich als
                        Buchungsbestätigung bezeichnet ist.</p>
                    <p>(4) Der Anbieter ist berechtigt, einen Termin abzulehnen, insbesondere wenn die Behandlung
                        außerhalb des Tätigkeitsbereichs liegt oder eine vertrauensvolle Behandlung nicht möglich
                        erscheint.</p>

                    <h2>§ 5 Heilpraktiker-Leistungen (Bereich A)</h2>
                    <p>(1) Der Anbieter erbringt psychotherapeutische Leistungen ausschließlich im Rahmen seiner
                        Erlaubnis als Heilpraktiker für Psychotherapie. Die Leistungen ersetzen <strong>keine</strong>
                        ärztliche, psychiatrische oder psychologisch-psychotherapeutische Behandlung im Sinne des
                        Psychotherapeutengesetzes. Bei akuten Krisen oder in Notfällen hat sich der Patient unverzüglich
                        an einen Arzt, den ärztlichen Notdienst (Tel. 116117), den Notruf (112) oder eine
                        Krisen-/Telefonseelsorge zu wenden.</p>
                    <p>(2) Der Behandlungsvertrag ist ein Dienstvertrag (§§&nbsp;611, 630a&nbsp;ff. BGB). Geschuldet
                        wird die fachgerechte Durchführung der Behandlung nach den anerkannten Regeln der angewandten
                        Verfahren, <strong>nicht</strong> ein bestimmter Behandlungs- oder Heilerfolg. Ein solcher
                        Erfolg wird nicht versprochen und kann nicht garantiert werden.</p>
                    <p>(3) Die Leistungen sind grundsätzlich nicht erstattungsfähig durch die gesetzliche
                        Krankenversicherung. Eine etwaige Kostenerstattung durch private Krankenversicherungen,
                        Beihilfestellen oder Zusatzversicherungen liegt allein im Verhältnis zwischen dem Patienten und
                        seinem Versicherer; eine Erstattung wird vom Anbieter nicht zugesichert.</p>
                    <p>(4) <strong>Terminabsage / Ausfallhonorar:</strong> Vereinbarte Termine sind verbindlich. Kann
                        ein Termin nicht wahrgenommen werden, ist er spätestens <span class="legal-doc__todo">[24 /
                            48]</span> Stunden vorher abzusagen. Bei nicht oder nicht rechtzeitig abgesagten Terminen
                        kann der Anbieter ein angemessenes Ausfallhonorar in Höhe von <span
                            class="legal-doc__todo">[Betrag / Prozentsatz des Behandlungshonorars]</span> berechnen,
                        sofern der freigewordene Termin nicht anderweitig vergeben werden konnte. Dem Patienten bleibt
                        der Nachweis vorbehalten, dass kein oder ein geringerer Ausfallschaden entstanden ist.</p>
                    <p>(5) Einzelheiten zur Vergütung der Behandlung werden gesondert in einer
                        Honorar-/Vergütungsvereinbarung geregelt; im Übrigen gilt §&nbsp;7.</p>

                    <h2>§ 6 Digitale Inhalte und Abonnements (Bereich B)</h2>
                    <p>(1) <strong>Vertragsschluss.</strong> Die Darstellung der digitalen Inhalte und Abonnements im
                        Online-Shop stellt kein bindendes Angebot dar. Durch Anklicken der Schaltfläche
                        „zahlungspflichtig bestellen“ (oder einer entsprechend eindeutigen Formulierung) gibt der Kunde
                        ein verbindliches Angebot ab. Der Vertrag kommt durch die Annahmeerklärung des Anbieters, durch
                        die Bereitstellung des Inhalts bzw. des Zugangs oder durch eine ausdrückliche Bestätigung in
                        Textform zustande.</p>
                    <p>(2) <strong>Bereitstellung.</strong> Digitale Inhalte werden nach Vertragsschluss und – soweit
                        erforderlich – nach Zahlungseingang bereitgestellt, indem sie zum Abruf, Download oder Streaming
                        auf der Plattform freigeschaltet werden. Für den Zugriff können bestimmte technische
                        Voraussetzungen erforderlich sein (<span class="legal-doc__todo">[z.&nbsp;B. aktueller
                            Internetbrowser, stabile Internetverbindung]</span>).</p>
                    <p>(3) <strong>Aktualisierungen.</strong> Soweit es sich um digitale Produkte handelt, stellt der
                        Anbieter dem Kunden während des maßgeblichen Zeitraums die Aktualisierungen bereit, die
                        erforderlich sind, damit das digitale Produkt vertragsgemäß bleibt (§&nbsp;327f BGB).</p>
                    <p>(4) <strong>Abonnements – Laufzeit und Verlängerung.</strong> Ein Abonnement hat eine
                        Mindestlaufzeit von <span class="legal-doc__todo">[z.&nbsp;B. 1 Monat / 12 Monate]</span>. Es
                        verlängert sich nach Ablauf der Mindestlaufzeit auf unbestimmte Zeit, sofern es nicht zuvor
                        gekündigt wird; in diesem Fall ist es jederzeit mit einer Frist von einem Monat kündbar. Wird
                        eine automatische Verlängerung um einen befristeten Zeitraum vereinbart, gelten die gesetzlichen
                        Grenzen des §&nbsp;309 Nr.&nbsp;9 BGB.</p>
                    <p>(5) <strong>Kündigung von Abonnements.</strong> Die Kündigung bedarf keiner besonderen Form und
                        kann über die auf der Plattform bereitgestellte Kündigungsschaltfläche („Verträge hier
                        kündigen“, §&nbsp;312k BGB) oder per E-Mail an <a :href="mailto">{{ email }}</a> erklärt werden.
                        Das
                        Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>

                    <h2>§ 7 Preise und Zahlungsbedingungen</h2>
                    <p>(1) <strong>Bereich A – Heilpraktiker-Leistungen.</strong> Die Vergütung der Behandlung richtet
                        sich nach der gesonderten Honorar-/Vergütungsvereinbarung. Heilbehandlungen im Bereich der
                        Humanmedizin durch Heilpraktiker sind nach §&nbsp;4 Nr.&nbsp;14 UStG von der Umsatzsteuer
                        befreit; die genannten Honorare verstehen sich daher ohne Umsatzsteuer. Die Behandlungsleistung
                        wird nach Erbringung in Rechnung gestellt und ist innerhalb von <span
                            class="legal-doc__todo">[14]</span> Tagen ab Rechnungsdatum ohne Abzug zur Zahlung fällig,
                        sofern nichts anderes vereinbart ist.</p>
                    <p>(2) <strong>Bereich B – Digitale Inhalte und Abonnements.</strong> Alle im Online-Shop
                        angegebenen Preise sind Endpreise und enthalten die gesetzliche Umsatzsteuer in jeweils gültiger
                        Höhe. Bei Abonnements wird das Entgelt zu Beginn des jeweiligen Abrechnungszeitraums (<span
                            class="legal-doc__todo">[monatlich / jährlich]</span>) im Voraus fällig.</p>
                    <p>(3) <strong>Zahlungsarten.</strong> Es stehen folgende Zahlungsarten zur Verfügung:
                        SEPA-Lastschrift, Kreditkarte und PayPal. Der Anbieter behält sich vor, einzelne Zahlungsarten
                        im Einzelfall nicht anzubieten.</p>
                    <p>(4) <strong>SEPA-Lastschrift.</strong> Bei Zahlung per SEPA-Lastschrift ermächtigt der Kunde den
                        Anbieter durch Erteilung eines SEPA-Lastschriftmandats, die fälligen Beträge von dem angegebenen
                        Konto einzuziehen. Die Frist für die Vorabinformation (Pre-Notification) wird auf <span
                            class="legal-doc__todo">[1]</span> Tag(e) verkürzt. Der Kunde stellt die Deckung des Kontos
                        sicher; durch eine Rücklastschrift entstehende Kosten trägt der Kunde, soweit er die
                        Rücklastschrift zu vertreten hat.</p>
                    <p>(5) <strong>Zahlungsverzug.</strong> Gerät der Kunde in Zahlungsverzug, ist der Anbieter
                        berechtigt, Verzugszinsen in gesetzlicher Höhe zu verlangen sowie – bei Abonnements und Zugängen
                        – die Bereitstellung bis zum vollständigen Ausgleich auszusetzen.</p>

                    <h2>§ 8 Widerrufsrecht für Verbraucher</h2>
                    <p>Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Über dieses unterrichtet der Anbieter wie
                        folgt:</p>

                    <h3>Widerrufsbelehrung</h3>
                    <p><strong>Widerrufsrecht</strong></p>
                    <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
                    </p>
                    <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses (bei Verträgen über
                        digitale Inhalte und Dienstleistungen sowie bei Verträgen über die Erbringung von
                        Dienstleistungen).</p>
                    <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Rüdiger Keilberg, Annastraße 9, 34119 Kassel,
                        Telefon: <a :href="phoneHref">{{ phone }}</a>, E-Mail: <a :href="mailto">{{ email }}</a>)
                        mittels einer eindeutigen
                        Erklärung (z.&nbsp;B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss,
                        diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte
                        Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.</p>
                    <p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
                        Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p>
                    <p><strong>Folgen des Widerrufs</strong></p>
                    <p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten
                        haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
                        Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung
                        verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt
                        haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
                        Ihnen wegen dieser Rückzahlung Entgelte berechnet.</p>
                    <p>Haben Sie verlangt, dass die Dienstleistung während der Widerrufsfrist beginnen soll, so haben
                        Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zum Zeitpunkt, zu dem Sie
                        uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits
                        erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen
                        Dienstleistungen entspricht.</p>
                    <p><strong>Besondere Hinweise zum vorzeitigen Erlöschen des Widerrufsrechts</strong></p>
                    <p>Bei einem Vertrag zur Erbringung von Dienstleistungen (Bereich A) erlischt das Widerrufsrecht,
                        wenn wir die Dienstleistung vollständig erbracht haben und mit der Ausführung erst begonnen
                        haben, nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben und gleichzeitig Ihre Kenntnis
                        davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung durch uns
                        verlieren.</p>
                    <p>Bei einem Vertrag über die Bereitstellung von nicht auf einem körperlichen Datenträger
                        befindlichen digitalen Inhalten (Bereich B) erlischt das Widerrufsrecht, wenn wir mit der
                        Ausführung des Vertrags begonnen haben, nachdem Sie ausdrücklich zugestimmt haben, dass wir mit
                        der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und Sie Ihre Kenntnis davon
                        bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr
                        Widerrufsrecht verlieren, und wir Ihnen eine Bestätigung hierüber zur Verfügung gestellt haben.
                    </p>
                    <p class="legal-doc__muted">– Ende der Widerrufsbelehrung –</p>

                    <h3>Muster-Widerrufsformular</h3>
                    <p>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie
                        es zurück.)</p>
                    <div class="legal-doc__box">
                        <p>An: Rüdiger Keilberg, Annastraße 9, 34119 Kassel, E-Mail: <a :href="mailto">{{ email }}</a>
                        </p>
                        <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf
                            der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*):</p>
                        <p>
                            Bestellt am (*)/erhalten am (*): __________<br />
                            Name des/der Verbraucher(s): __________<br />
                            Anschrift des/der Verbraucher(s): __________<br />
                            Datum: __________<br />
                            Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier): __________
                        </p>
                        <p class="legal-doc__muted">(*) Unzutreffendes streichen.</p>
                    </div>

                    <h2>§ 9 Nutzungsrechte an digitalen Inhalten</h2>
                    <p>(1) Der Anbieter räumt dem Kunden an den erworbenen digitalen Inhalten ein einfaches, nicht
                        ausschließliches, nicht übertragbares und zeitlich auf die Vertragslaufzeit beschränktes Recht
                        zur Nutzung für eigene, private Zwecke ein.</p>
                    <p>(2) Dem Kunden ist es insbesondere untersagt, die Inhalte ganz oder teilweise zu vervielfältigen,
                        öffentlich zugänglich zu machen, weiterzuverbreiten, zu vermieten, zu verkaufen, Dritten Zugang
                        zu gewähren oder sie außerhalb des vertraglich vorgesehenen Rahmens zu bearbeiten. Sämtliche
                        Urheber- und Leistungsschutzrechte verbleiben beim Anbieter bzw. den jeweiligen Rechteinhabern.
                    </p>

                    <h2>§ 10 Pflichten und Verantwortlichkeit des Kunden</h2>
                    <p>(1) Der Kunde ist verpflichtet, bei der Registrierung und Buchung wahrheitsgemäße und
                        vollständige Angaben zu machen.</p>
                    <p>(2) Zugangsdaten zur Plattform sind geheim zu halten und vor dem Zugriff Dritter zu schützen. Der
                        Kunde informiert den Anbieter unverzüglich, wenn Anhaltspunkte für eine missbräuchliche Nutzung
                        seines Zugangs bestehen.</p>
                    <p>(3) Die Angebote richten sich an volljährige Personen. <span class="legal-doc__todo">[Soweit
                            Angebote für Minderjährige zugänglich gemacht werden sollen, ist eine gesonderte Regelung
                            zur Einwilligung der Erziehungsberechtigten erforderlich.]</span></p>

                    <h2>§ 11 Verfügbarkeit der Plattform</h2>
                    <p>(1) Der Anbieter bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit der Plattform,
                        schuldet diese jedoch nicht ununterbrochen. Wartungsarbeiten, Sicherheitsmaßnahmen oder
                        Störungen, die nicht im Einflussbereich des Anbieters liegen (z.&nbsp;B. höhere Gewalt, Ausfälle
                        von Drittanbietern), können zu vorübergehenden Einschränkungen führen.</p>
                    <p>(2) Notwendige Wartungsarbeiten kündigt der Anbieter nach Möglichkeit rechtzeitig an und führt
                        sie vorzugsweise in nutzungsarmen Zeiten durch.</p>

                    <h2>§ 12 Mängelhaftung / Gewährleistung</h2>
                    <p>(1) Für die Bereitstellung digitaler Inhalte und digitaler Dienstleistungen gelten die
                        gesetzlichen Vorschriften, insbesondere die §§&nbsp;327&nbsp;ff. BGB. Der Anbieter haftet dafür,
                        dass die digitalen Produkte den vereinbarten Anforderungen entsprechen und frei von
                        Produktmängeln sind.</p>
                    <p>(2) Für die Heilpraktiker-Leistungen gelten die gesetzlichen Vorschriften des Dienst- und
                        Behandlungsvertragsrechts (§§&nbsp;611, 630a&nbsp;ff. BGB).</p>

                    <h2>§ 13 Haftung</h2>
                    <p>(1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder
                        der Gesundheit, die auf einer Pflichtverletzung des Anbieters oder seiner Erfüllungsgehilfen
                        beruhen, sowie für Schäden, die auf Vorsatz oder grober Fahrlässigkeit beruhen.</p>
                    <p>(2) Bei der leicht fahrlässigen Verletzung wesentlicher Vertragspflichten (Pflichten, deren
                        Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren
                        Einhaltung der Kunde regelmäßig vertraut – sog. Kardinalpflichten) ist die Haftung auf den
                        vertragstypischen, vorhersehbaren Schaden begrenzt.</p>
                    <p>(3) Im Übrigen ist die Haftung für leicht fahrlässig verursachte Schäden ausgeschlossen.</p>
                    <p>(4) Die Haftung nach dem Produkthaftungsgesetz sowie aufgrund übernommener Garantien bleibt
                        unberührt.</p>
                    <p>(5) Die vorstehenden Haftungsbeschränkungen gelten nicht für die Haftung im Rahmen der
                        psychotherapeutischen Behandlung, soweit diese die Gesundheit des Patienten betrifft (vgl.
                        Abs.&nbsp;1).</p>

                    <h2>§ 14 Datenschutz</h2>
                    <p>(1) Der Anbieter verarbeitet personenbezogene Daten ausschließlich im Rahmen der gesetzlichen
                        Bestimmungen. Einzelheiten zur Verarbeitung personenbezogener Daten ergeben sich aus der
                        Datenschutzerklärung unter <span class="legal-doc__todo"><a
                                href="/datenschutzerklaerung">Datenschutzerklärung</a></span>.
                    </p>
                    <p>(2) Im Rahmen der Behandlung anvertraute oder bekannt gewordene Daten unterliegen der
                        gesetzlichen Schweigepflicht (§&nbsp;203 StGB). Gesundheitsdaten werden als besondere Kategorien
                        personenbezogener Daten im Sinne des Art.&nbsp;9 DSGVO mit erhöhter Sorgfalt behandelt und nur
                        auf Grundlage einer gesetzlichen Erlaubnis oder einer ausdrücklichen Einwilligung des Patienten
                        verarbeitet.</p>

                    <h2>§ 15 Vertragstext und Vertragssprache</h2>
                    <p>(1) Die Vertragssprache ist Deutsch.</p>
                    <p>(2) Der Anbieter speichert den Vertragstext der Bestellung im Bereich B und sendet dem Kunden die
                        Bestelldaten sowie diese AGB in Textform (z.&nbsp;B. per E-Mail) zu. Die AGB können jederzeit
                        auf der Plattform abgerufen und gespeichert werden.</p>

                    <h2>§ 16 Verbraucherstreitbeilegung</h2>
                    <p>Der Anbieter ist zur Teilnahme an einem Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle <strong>bereit</strong>. Zuständig ist die Allgemeine
                        Verbraucherschlichtungsstelle des Zentrums für Schlichtung e.&nbsp;V.
                        (Universalschlichtungsstelle des Bundes), Straßburger Straße 8, 77694 Kehl am Rhein, <a
                            href="https://www.verbraucher-schlichter.de" target="_blank"
                            rel="noopener">www.verbraucher-schlichter.de</a>.</p>

                    <h2>§ 17 Schlussbestimmungen</h2>
                    <p>(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Bei
                        Verbrauchern gilt diese Rechtswahl nur, soweit hierdurch der durch zwingende Bestimmungen des
                        Rechts des Staates des gewöhnlichen Aufenthalts des Verbrauchers gewährte Schutz nicht entzogen
                        wird.</p>
                    <p>(2) Sofern es sich beim Kunden um einen Kaufmann, eine juristische Person des öffentlichen Rechts
                        oder ein öffentlich-rechtliches Sondervermögen handelt, ist Gerichtsstand für alle
                        Streitigkeiten aus Vertragsverhältnissen der Geschäftssitz des Anbieters.</p>
                    <p>(3) Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, so
                        wird hierdurch die Wirksamkeit der übrigen Bestimmungen nicht berührt.</p>

                    <p class="legal-doc__updated">Stand: {{ lastUpdated }}</p>
                </article>
            </v-col>
            <v-spacer />
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "agb",
    data() {
        return {
            lastUpdated: 'Mai 2026',
            obfuscatedEmail: "kontakt[at]praxis-keilberg[dot]de",
            obfuscatedPhone: "+49-1515-0850942"
        }
    },
    computed: {
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
        email() {
            return this.obfuscatedEmail
                .replace('[at]', '@')
                .replace('[dot]', '.')
        },
        mailto() {
            return `mailto:${this.email}`
        },

        phone() {
            return this.obfuscatedPhone
                .replaceAll('-', '')
        },

        phoneHref() {
            return `tel:${this.obfuscatedPhone.replaceAll('-', '')}`
        }
    }
}
</script>

<style scoped>
.legal-doc {
    margin-inline: auto;
    padding: clamp(1.25rem, 4vw, 2.5rem);
    font-family: inherit;
    font-size: 1rem;
    line-height: 1.7;
    text-align: left;
    -webkit-text-size-adjust: 100%;
}

.legal-doc__title {
    font-size: clamp(1.6rem, 4vw, 2.1rem);
    line-height: 1.25;
    font-weight: 700;
    margin: 0 0 1.5rem;
    letter-spacing: -0.01em;
}

.legal-doc :is(h2) {
    font-size: 1.2rem;
    font-weight: 700;
    margin: 2.4rem 0 0.75rem;
    padding-bottom: 0.4rem;
}

.legal-doc :is(h3) {
    font-size: 1.02rem;
    font-weight: 700;
    margin: 1.6rem 0 0.5rem;
}

.legal-doc p {
    margin: 0 0 0.9rem;
}

.legal-doc ul {
    margin: 0 0 0.9rem;
    padding-left: 1.4rem;
}

.legal-doc li {
    margin: 0 0 0.45rem;
}

.legal-doc a {
    color: rgb(var(--v-theme-primary));
    text-decoration: underline;
    text-underline-offset: 2px;
    overflow-wrap: anywhere;
}

.legal-doc strong {
    font-weight: 700;
}

.legal-doc address {
    font-style: normal;
    margin: 0 0 0.9rem;
}

.legal-doc__box {
    border-radius: 8px;
    padding: 1rem 1.25rem;
    margin: 0 0 1rem;
}

.legal-doc__box p:last-child {
    margin-bottom: 0;
}

.legal-doc__muted {
    opacity: 0.7
}

.legal-doc__updated {
    margin-top: 2.5rem;
    font-size: 0.9rem;
}

.legal-doc__todo {
    padding: 0 0.25em;
    border-radius: 3px;
    font-style: italic;
}
</style>
